import Background3D from "../components/Background3D";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import ServiceForm from "../components/ServiceForm";
import SuccessStories from "../components/SuccessStories";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import "./Home.css";

export default function Home() {
  return (
    <div className="home">
      <Background3D />
      <Navbar />
      <main>
        <Hero />
        <ServiceForm />
        <Services />
        <WhyChooseUs />
        <SuccessStories />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
